import { useIsAuthorized } from '@modules/common/components/CanAccess/hooks';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import {
  DashboardUseCase,
  DashboardViewFragment,
  Status,
} from 'generated/graphql';
import { DATE_FORMAT } from 'v2/core/date/date';

interface DashboardAdditionalDetailsProps {
  dashboard: Pick<
    DashboardViewFragment,
    'createdBy' | 'createdAt' | 'scope' | 'status' | 'useCase'
  >;
  shouldShowAbsoluteTime?: boolean;
}

export const DashboardAdditionalDetails = ({
  dashboard,
  shouldShowAbsoluteTime,
}: DashboardAdditionalDetailsProps) => {
  const isArchived = dashboard.status === Status.Archived;
  const isTemplate = dashboard?.useCase === DashboardUseCase.Template;

  const createdAt = dayjs.unix(dashboard.createdAt);

  const canManageTemplates = useIsAuthorized({
    resource: PermissionResource.Template,
    operation: PermissionOperation.Write,
  });

  return (
    <Typography variant="body2" color="text.secondary">
      Dashboard {isTemplate && canManageTemplates ? 'Template' : ''}
      {' • '}
      {dashboard.createdBy.firstName} {dashboard.createdBy.lastName}
      {' • '}
      {shouldShowAbsoluteTime
        ? createdAt.tz().format(DATE_FORMAT)
        : createdAt.toNow(true)}
      {!shouldShowAbsoluteTime && ' ago'}
      {isArchived ? ' • Archived' : ''}
    </Typography>
  );
};
